import PropTypes from "prop-types"
import { connect } from "react-redux"
import PreferenceRedirect from "./preferenceRedirect"

function PlanConditionalPreferenceRedirect({ plan, defaultRedirect, proRedirect, preferenceSubType }) {
  const planConditionalRedirect = plan === "pro" ? proRedirect : defaultRedirect

  return <PreferenceRedirect preferenceSubType={preferenceSubType} defaultRedirect={planConditionalRedirect} />
}

PlanConditionalPreferenceRedirect.propTypes = {
  plan: PropTypes.string.isRequired,
  preferenceSubType: PropTypes.string.isRequired,
  defaultRedirect: PropTypes.string.isRequired,
  proRedirect: PropTypes.string.isRequired,
}

const mapStateToProps = (state) => ({
  plan: state.global.selected.accountMeta.plan,
})

export default connect(mapStateToProps)(PlanConditionalPreferenceRedirect)
